/* eslint-disable react/prop-types */
import React from 'react';

import {cn} from 'spa/css';

import './PageLoading.less';

export const PageLoading = ({className, ...rest}) => (
  <div className={cn(className, 'PageLoading')} {...rest} />
);

export const PageLoadingTitle = ({className, ...rest}) => (<div
  className={cn(className, 'placeholder-box PageLoading-title')}
  {...rest}
/>);
export const PageLoadingSubtitle = ({className, ...rest}) => (<div
  className={cn(className, 'placeholder-box PageLoading-subtitle')}
  {...rest}
/>);

export const PageLoadingLine = ({className, ...rest}) => (<div
  className={cn(className, 'placeholder-box PageLoading-line')}
  {...rest}
/>);

export default PageLoading;



// WEBPACK FOOTER //
// ./spa/Components/PageLoading.jsx